(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dogheroes--video-steps"] && !Shopify.designMode) return;
  try {
    
  class DHVideoSteps extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('.dh-vsteps__row'))
      this.heads = Array.from(this.querySelectorAll('.dh-vsteps__head'))
      this.mediaPanels = Array.from(this.querySelectorAll('.dh-vsteps__media-panel'))
      if (!this.rows.length) return

      this.activeIndex = this.rows.findIndex((r) => r.classList.contains('is-active'))
      if (this.activeIndex < 0) this.activeIndex = 0
      this.inView = false

      const rm = window.matchMedia('(prefers-reduced-motion: reduce)')
      this.allowAutoplay = !rm.matches || this.hasAttribute('data-allow-reduced-motion')

      this.heads.forEach((head, i) => {
        head.addEventListener('click', () => this.activate(i))
      })

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.inView = entry.isIntersecting
            if (entry.isIntersecting) {
              this.playActive()
            } else {
              this.pauseAll()
            }
          })
        },
        { threshold: 0.35 }
      )
      this.observer.observe(this)
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect()
    }

    activate(index) {
      if (index === this.activeIndex) {
        this.playActive()
        return
      }
      this.activeIndex = index

      this.rows.forEach((row, i) => {
        const on = i === index
        row.classList.toggle('is-active', on)
        const head = row.querySelector('.dh-vsteps__head')
        if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false')
      })

      this.mediaPanels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index)
      })

      this.resetInactiveMedia()
      this.playActive()
    }

    playActive() {
      if (!this.inView || !this.allowAutoplay) return
      const panel = this.mediaPanels[this.activeIndex]
      if (!panel) return

      const video = panel.querySelector('video[data-dh-media]')
      if (video) {
        video.muted = true
        const p = video.play()
        if (p && typeof p.catch === 'function') p.catch(() => {})
      }

      const embed = panel.querySelector('[data-dh-embed]')
      if (embed && !embed.querySelector('iframe')) this.mountEmbed(embed)
    }

    pauseAll() {
      this.mediaPanels.forEach((panel) => {
        const video = panel.querySelector('video[data-dh-media]')
        if (video) video.pause()
      })
    }

    resetInactiveMedia() {
      this.mediaPanels.forEach((panel, i) => {
        if (i === this.activeIndex) return
        const video = panel.querySelector('video[data-dh-media]')
        if (video) {
          video.pause()
          try {
            video.currentTime = 0
          } catch (e) {}
        }
        const embed = panel.querySelector('[data-dh-embed]')
        if (embed) this.unmountEmbed(embed)
      })
    }

    mountEmbed(embed) {
      const type = embed.dataset.embedType
      const id = embed.dataset.embedId
      let src = ''
      if (type === 'youtube') {
        src =
          'https://www.youtube.com/embed/' +
          id +
          '?autoplay=1&mute=1&loop=1&playlist=' +
          id +
          '&controls=0&playsinline=1&rel=0&modestbranding=1'
      } else if (type === 'vimeo') {
        src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&muted=1&loop=1&background=1'
      }
      if (!src) return
      const iframe = document.createElement('iframe')
      iframe.src = src
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture'
      iframe.setAttribute('allowfullscreen', '')
      iframe.loading = 'lazy'
      iframe.title = embed.dataset.embedTitle || ''
      embed.appendChild(iframe)
    }

    unmountEmbed(embed) {
      const iframe = embed.querySelector('iframe')
      if (iframe) iframe.remove()
    }
  }

  if (!customElements.get('dh-video-steps')) {
    customElements.define('dh-video-steps', DHVideoSteps)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
